(function() {
    'use strict';

    angular.module('user')
        .controller('ModelPermissionsGroupUpdateController', ModelPermissionsGroupUpdateController);

    ModelPermissionsGroupUpdateController.$inject = ['$state', 'modelPermissionsGroupDataSrvc', 'notificationSrvc', 'modelPermissionsGroupMessagesConst', 'modelPermissionsDataSrvc'];

    function ModelPermissionsGroupUpdateController($state, modelPermissionsGroupDataSrvc, notificationSrvc, modelPermissionsGroupMessagesConst, modelPermissionsDataSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            permissions: [],
            nonFieldErrors: []
        };
        self.modelPermissionsGroupData = {
            name: '',
            permissions: [],
        };
        self.permissionList = [];

        self.updateModelPermissionsGroup = updateModelPermissionsGroup;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getModelPermissionsGroup();
            getPermissionList();
        }

        function getModelPermissionsGroup() {
            return modelPermissionsGroupDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(
                function(response) {
                    self.modelPermissionsGroupData = response;
                }
            );
        }

        function getPermissionList() {
            return modelPermissionsDataSrvc.modelPermissions().$promise.then(
                function(response) {
                    self.permissionList = response;
                    return response;
                }
            );
        }

        function updateModelPermissionsGroup() {
            modelPermissionsGroupDataSrvc.update({
                pk: self.modelPermissionsGroupData.pk
            }, self.modelPermissionsGroupData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", modelPermissionsGroupMessagesConst.update);
                    $state.go('layout.modelPermissionsGroup.list');
                },
                function(response) {
                    notificationSrvc.notification("success", modelPermissionsGroupMessagesConst.error);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
